import Vue from 'vue';
import Router from 'vue-router';

import Login from '../components/Login';
import Main from '../components/Main';
import List from '../components/List';
import Detail016001 from '../components/016001/Detail';
import Detail016002 from '../components/016002/Detail';
import DetailTBM016001 from '../components/016001/DetailTBM';
import DetailTBM016002 from '../components/016002/DetailTBM';
import Step1 from '../components/Step1';
import Step2 from '../components/Step2';
import Step2TBM from '../components/Step2TBM';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                bodyClass: 'login'
            }
        },
        {
            path: '/',
            name: 'Main',
            alias: '/main',
            component: Main,
            meta: {
                bodyClass: 'main'
            }
        },
        {
            path: '/list',
            name: 'List',
            component: List,
            meta: {
                bodyClass: 'list'
            }
        },
        {
            path: '/detail/016001/:id',
            name: 'Detail',
            component: Detail016001,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/detail/016002/:id',
            name: 'Detail',
            component: Detail016002,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/detailTBM/016001/:id',
            name: 'DetailTBM',
            component: DetailTBM016001,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/detailTBM/016002/:id',
            name: 'DetailTBM',
            component: DetailTBM016002,
            meta: {
                bodyClass: 'detail'
            }
        },
        {
            path: '/step1/:id?',
            name: 'Step1',
            component: Step1,
            meta: {
                bodyClass: 'step1'
            }
        },
        {
            path: '/step2/:id?',
            name: 'Step2',
            component: Step2,
            meta: {
                bodyClass: 'step2'
            }
        },
        {
            path: '/step2TBM/:id?',
            name: 'Step2TBM',
            component: Step2TBM,
            meta: {
                bodyClass: 'step2'
            }
        }
    ]
});

export default router;
